import {
  Menu,
  MenuList,
  MenuOptionGroup,
  MenuItemOption,
  Portal,
} from '@cdl/heartbeat-react';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as layoutActions from '../layout/actions/layout.actions';
import { displaySelector } from '../layout/selectors/layout.selectors';
import { RestingDisplay, DISPLAY_SYSTEMS } from './resting.util';
import { MenuButtonWithTooltip } from '../../shared/components/MenuButtonWithTooltip';

export const DisplayDropdown: React.FC = () => {
  const dispatch = useDispatch();
  const selectedDisplay = useSelector(displaySelector);

  const onChangeDisplay = useCallback(
    (display: RestingDisplay) => {
      dispatch(layoutActions.update({ update: { display } }));
    },
    [dispatch],
  );

  return (
    <Menu>
      <MenuButtonWithTooltip
        tooltipLabel='Display System'
        data-testid='display-dropdown'
        px='s'
      >
        {selectedDisplay}
      </MenuButtonWithTooltip>
      <Portal>
        <MenuList minWidth='unset'>
          <MenuOptionGroup
            type='radio'
            value={selectedDisplay}
            onChange={(v) => onChangeDisplay(v as RestingDisplay)}
          >
            {DISPLAY_SYSTEMS.map((displaySystem) => (
              <MenuItemOption value={displaySystem} key={displaySystem}>
                {displaySystem}
              </MenuItemOption>
            ))}
          </MenuOptionGroup>
        </MenuList>
      </Portal>
    </Menu>
  );
};
